import Pager from '@/components/view/atoms/pager/Pager'

interface Props {
  page: number
  perPage: number
  total: number
  onPrev(page: number): void
  onNext(page: number): void
}

const Pagination = ({ page, perPage, total, onPrev, onNext }: Props) => {
  const provisionalTo = perPage * page
  return (
    <>
      {!!total && (
        <Pager
          onClickPrev={page != 1 ? () => onPrev(page - 1) : undefined}
          onClickNext={provisionalTo >= total ? undefined : () => onNext(page + 1)}
          onClickFirst={page != 1 ? () => onPrev(1) : undefined}
          onClickLast={
            provisionalTo >= total ? undefined : () => onNext(Math.ceil(total / perPage))
          }
          from={perPage * (page - 1) + 1}
          to={provisionalTo < total ? provisionalTo : total}
          total={total}
        />
      )}
    </>
  )
}

export default Pagination
